import graphql from 'babel-plugin-relay/macro';
import { fetchQuery } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();
      
const query = graphql`
query AppFetchForSOQuery($accountId: UUID!, $appId: UUID, $domainSearch: String) {
  appsearchforsopopulation(accountid: $accountId, appid: $appId, domainsearch: $domainSearch) {
      totalCount
      nodes {
        appId
        accountId
        appStatus
        appName
        appSku
        appUrl
        signupUrl
        appLogo
        description
        appType
        parentAppId
        oemAppId
        atId
        appSkuPrice
        appMarkupAbsolute
        appMarkupPercentage
        jitFloatDefault
        marqetaMid
        marqetaMname
        maxCharge
        paymentOrder
        passThroughFees
        wholesaleDiscountPercentage
        billingFrequency
        showDomain
        showUsername
      }
    }
  }
`;

function fetch(acctId, appId, domainSearch) {
  const variables = {
    accountId: acctId
  }
  if (appId) {
    variables.appId = appId;
  }
  if (domainSearch) {
    variables.domainSearch = domainSearch;
  }


  return fetchQuery(
    abEnvironment.getEnvironment(),
    query,
    variables
  );
}
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { fetch };

